module.exports = __webpack_public_path__ + "static/media/rndTcs_logo.0927764c.png";